import React from "react";
import {
  AreaChart,
  Area,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ReferenceLine,
  ResponsiveContainer,
} from "recharts";

const doorToNeedleStrokeDayWise = [
  { label: "Mon", avgTime: 56 },
  { label: "Tue", avgTime: 54 },
  { label: "Wed", avgTime: 52 },
  { label: "Thu", avgTime: 55 },
  { label: "Fri", avgTime: 53 },
  { label: "Sat", avgTime: 59 },
  { label: "Sun", avgTime: 58 },
];

/* Tooltip */
const StrokeDTNTooltip = ({ active, payload, label }) => {
  if (!active || !payload?.length) return null;

  return (
    <div className="bg-white p-3 rounded-lg shadow-md border text-sm min-w-[180px]">
      <p className="font-semibold mb-1">{label}</p>
      <div className="flex justify-between font-semibold text-purple-900">
        <span>Avg DTN Time</span>
        <span>{payload[0].value} min</span>
      </div>
    </div>
  );
};

export default function DoorToNeedleStrokeChart() {
  return (
    <ResponsiveContainer width="100%" height="100%">
      <AreaChart
        data={doorToNeedleStrokeDayWise}
        margin={{ top: 10, right: 10, left: -10, bottom: 0 }}
      >
        {/* Stroke Gradient */}
        <defs>
          <linearGradient id="strokeGradient" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0%" stopColor="#6D28D9" stopOpacity={0.45} />
            <stop offset="100%" stopColor="#6D28D9" stopOpacity={0} />
          </linearGradient>
        </defs>

        <CartesianGrid
          strokeDasharray="3 3"
          vertical={false}
          stroke="#e5e7eb"
        />

        <XAxis dataKey="label" tick={{ fontSize: 12 }} stroke="#6b7280" />
        <YAxis
          interval={0}
          tick={{ fontSize: 12 }}
          stroke="#6b7280"
          tickFormatter={(v) => `${v}m`}
        />

        {/* Target Line */}
        {/* <ReferenceLine
          y={60}
          stroke="#7C3AED"
          strokeDasharray="4 4"
          label={{
            value: "Target ≤ 60 min",
            position: "right",
            fill: "#7C3AED",
            fontSize: 11,
          }}
        /> */}

        <Tooltip content={<StrokeDTNTooltip />} />

        <Area
          type="monotone"
          dataKey="avgTime"
          stroke="#4C1D95"
          fill="url(#strokeGradient)"
          strokeWidth={3}
          dot={{
            r: 3,
            fill: "#4C1D95",
            stroke: "#4C1D95",
            strokeWidth: 3,
          }}
          activeDot={{ r: 3 }}
        />
      </AreaChart>
    </ResponsiveContainer>
  );
}
